import { Component } from '@angular/core';
import { ItemAttributesStoreService } from '../item-attributes-store.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AttributeValuePipe } from '../attribute-value.pipe';
import { AttributeValueTimestampUserPipe } from '../attribute-value-timestamp-user.pipe';
import { MatButton } from '@angular/material/button';
import { TestIdDirective } from '../../directives/test-id.directive';
import { AttributeValueInputComponent } from '../attribute-value-input/attribute-value-input.component';
import { KeyValuePairComponent } from '../../general/key-value-pair/key-value-pair.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-update-attribute-value',
    templateUrl: './update-attribute-value.component.html',
    standalone: true,
    imports: [NgIf, KeyValuePairComponent, AttributeValueInputComponent, TestIdDirective, ReactiveFormsModule, MatButton, AsyncPipe, AttributeValueTimestampUserPipe, AttributeValuePipe]
})
export class UpdateAttributeValueComponent {
  attribute$ = this.store.updateAttribute$;
  formControl = new FormControl();

  constructor(private store: ItemAttributesStoreService) {}

  updateValue(attributeId: number) {
    this.store.setAttributeValue({
      attributeId,
      value: this.formControl.value as string
    });
  }

  cancel() {
    this.store.setView('list');
  }
}
